import {
  AccountSearchResultModel,
  BoardMeetingCaseResultModel,
  InvoiceSearchResultModel,
  MenuSearchResultModel,
} from '../model'
import React from 'react'

type IGlobalSearchContext = {
  error: unknown
  loading: boolean
  menuHits?: MenuSearchResultModel
  boardMeetingHits?: BoardMeetingCaseResultModel
  invoiceHits?: InvoiceSearchResultModel
  accountHits?: AccountSearchResultModel
}

export const GlobalSearchContext = React.createContext<IGlobalSearchContext>(
  {} as IGlobalSearchContext
)

export const useGlobalSearchContext = () => {
  const context = React.useContext(GlobalSearchContext)

  if (!context) {
    throw new Error(
      'useGlobalSearchContext must be used within a GlobalSearchProvider'
    )
  }

  return context
}
